import { ITableDataSourceItem } from "@/Common/Models/UI/Tables/ITableDataSourceItem";
import { PatientMessageItem } from "./PatientMessageItem";

class PatientMessageListItem implements ITableDataSourceItem<PatientMessageItem> {
    public Model: PatientMessageItem;
    public Name: string;

    constructor(model: PatientMessageItem) {
        this.Model = model;
    }
}

export { PatientMessageListItem };
